module.exports = __webpack_public_path__ + "img/Logo-2.25338f8a.svg";